import { render, staticRenderFns } from "./ResourceUpkeep.vue?vue&type=template&id=b491a868&scoped=true"
import script from "./ResourceUpkeep.vue?vue&type=script&lang=js"
export * from "./ResourceUpkeep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b491a868",
  null
  
)

export default component.exports